import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import {
    AgentApi,
    AgentApiImpl,
    AgentApiName,
} from './apis';
import { AgentApiImplV2 } from './apis/agent-api-v2';
import { ValidationApi, ValidationApiImpl } from './apis/validation-api';
import { AgentSettingsApi, AgentSettingsApiImpl } from './apis/agent-settings-api';
import { AgentAuthApi, AgentAuthApiImpl } from './apis/agent-auth-api';
import { AgentAuthService, AgentAuthServiceImpl } from './services/agent-auth-service';
import { NerNorApi, NerNorApiImpl } from './apis/ner-nor-api';
import { PnApi, PnApiImpl } from './apis/pn-api';
import { EmbodimentImagesApi, EmbodimentImagesApiImpl } from './apis/embodiment-images-api';
import { DrugApi, DrugApiImpl } from './apis/drug-api';
import { PccApi, PccApiImpl } from './apis/pcc-api';
import { PatentSignatureApi, PatentSignatureApiImpl } from './apis/patent-signature-api';
import { SarApi, SarApiImpl } from './apis/sar-api';
import { AgentUploadStrategy } from './services/upload/agent-upload-strategy';
import { BaseAgentUploadStrategy } from './services/upload/base-agent-upload-strategy';
import { LcaAgentUploadStrategy } from './services/upload/lca-agent-upload-strategy';
import { PdaAgentUploadStrategy } from './services/upload/pda-agent-upload-strategy';
import { SarAgentUploadStrategy } from './services/upload/sar-agent-upload-strategy';

export const agentContainer = new ContainerModule((bind) => {
    bind(AgentApi).to(AgentApiImpl).whenTargetIsDefault();
    bind(AgentApi).to(AgentApiImplV2).whenTargetNamed(AgentApiName.V2);
    bind(ValidationApi).to(ValidationApiImpl);
    bind(AgentSettingsApi).to(AgentSettingsApiImpl);
    bind(AgentAuthApi).to(AgentAuthApiImpl);
    bind(AgentAuthService).to(AgentAuthServiceImpl);
    bind(NerNorApi).to(NerNorApiImpl);
    bind(PnApi).to(PnApiImpl);
    bind(EmbodimentImagesApi).to(EmbodimentImagesApiImpl);
    bind(DrugApi).to(DrugApiImpl);
    bind(PccApi).to(PccApiImpl);
    bind(PatentSignatureApi).to(PatentSignatureApiImpl);
    bind(SarApi).to(SarApiImpl);
    bind(BaseAgentUploadStrategy).toSelf();
    bind(AgentUploadStrategy).to(LcaAgentUploadStrategy).whenTargetNamed('LCA');
    bind(AgentUploadStrategy).to(PdaAgentUploadStrategy).whenTargetNamed('PDA');
    bind(AgentUploadStrategy).to(SarAgentUploadStrategy).whenTargetNamed('SAR');
});
